import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ variant = 'default', className = '' }) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-dark-900';
  const subTextColor = variant === 'light' ? 'text-dark-300' : 'text-dark-400';

  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`}>
      <div className="relative">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-athletic-400 via-athletic-500 to-power-600 flex items-center justify-center transform group-hover:scale-105 transition-transform shadow-button">
          <span className="font-display font-bold text-white text-lg tracking-tighter">BT</span>
        </div>
        <div className="absolute -inset-1 bg-gradient-to-br from-athletic-400 to-power-600 rounded-xl blur opacity-25 group-hover:opacity-50 transition-opacity" />
      </div>
      <div className="flex flex-col leading-tight">
        <span className={`font-display font-bold text-xl tracking-tight ${textColor} transition-colors`}>
          Bright <span className="text-athletic-500">Tech</span>
        </span>
        <span className={`text-[10px] font-medium uppercase tracking-[0.22em] ${subTextColor} transition-colors`}>
          Tech Supply Co.
        </span>
      </div>
    </Link>
  );
};

export default Logo;
